import { requestHandler } from "../lib/utils/network-client";

export function getPublications(params = {}) {
  return requestHandler("/publications", {
    params
  });
}

export function createPublication(payload) {
  return requestHandler("/publications", {
    method: "POST",
    body: payload
  });
}

export function updatePublication(id, payload) {
  return requestHandler(`/publications/${id}`, {
    method: "PUT",
    body: payload
  });
}

export function deletePublication(id) {
  return requestHandler(`/publications/${id}`, {
    method: "DELETE"
  });
}
